module.exports = __webpack_public_path__ + "static/img/Vector 6.069deb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/Vector 6.png
// module id = ZBt4
// module chunks = 1